import React, { useEffect, useState } from 'react';

import BuyerAndNitexMeasurementTable from '@features/measurement/components/BuyerAndNitexMeasurementTable';
import CostingAndPPSampleTable from '@features/measurement/components/CostingAndPPSampleTable';

import { processFitWiseSizeList, processMeasurementData } from '@store/actions/MeasurementAction';

import { fetchLatestMeasurementTypeInfo } from '@services/measurementService';

const TechPackMeasurementSection = ({ productId, productInfo }) => {
	const [hasShowActualAndDiffColumn, setHasShowActualAndDiffColumn] = useState([]);
	const [initialMeasurementTableData, setInitialMeasurementTable] = useState([]);
	const [sizeCategorySequence, setSizeCategorySequence] = useState({});
	const [measurementTable, setMeasurementTable] = useState([]);
	const [fitWiseSizeList, setFitWiseSizeList] = useState({});
	const [pomAndSizeList, setPomAndSizeList] = useState([]);

	useEffect(() => {
		(async () => {
			try {
				const data = await fetchLatestMeasurementTypeInfo(productId);
				setPomAndSizeList(data);
				setInitialMeasurementTable(data?.tableData);
				setHasShowActualAndDiffColumn(data?.hasShowColumn);
				setSizeCategorySequence(data.sizeCategorySequenceMap);
				setMeasurementTable(processMeasurementData(data?.tableData));
				setFitWiseSizeList(processFitWiseSizeList(data?.tableData));
			} catch {
				/* Empty Block */
			}
		})();
	}, []);

	const renderMeasurementTables = () => {
		const renderTables = () => {
			if (
				['NITEX_DEVELOPMENT', 'BUYER_FIT_DEVELOPMENT'].includes(
					pomAndSizeList?.measurementType?.constant
				)
			) {
				let clone1 = JSON.parse(JSON.stringify(measurementTable));
				let clone2 = JSON.parse(JSON.stringify(measurementTable));
				let firstAndSecondFitTableData = clone1.map((item) => {
					let modifiedFitInfo = {};
					if (item.fitInfo?.FIRST_FIT) {
						modifiedFitInfo['FIRST_FIT'] = item.fitInfo.FIRST_FIT;
					}
					if (item.fitInfo?.SECOND_FIT) {
						modifiedFitInfo['SECOND_FIT'] = item.fitInfo.SECOND_FIT;
					}
					item.fitInfo = modifiedFitInfo;
					return item;
				});

				let secondAndThirdFitTableData = clone2.map((item) => {
					let modifiedFitInfo = {};
					if (item.fitInfo?.SECOND_FIT) {
						modifiedFitInfo['SECOND_FIT'] = item.fitInfo.SECOND_FIT;
					}
					if (item.fitInfo?.THIRD_FIT) {
						modifiedFitInfo['THIRD_FIT'] = item.fitInfo.THIRD_FIT;
					}
					item.fitInfo = modifiedFitInfo;
					return item;
				});
				let firstAndSecondFitInitialData = initialMeasurementTableData.slice(0, 2);
				let secondAndThirdFitInitialData = initialMeasurementTableData.slice(1);
				let firstTblSizeList = {};
				let secondTblSizeList = {};
				if (fitWiseSizeList?.FIRST_FIT) {
					firstTblSizeList['FIRST_FIT'] = fitWiseSizeList['FIRST_FIT'];
				}
				if (fitWiseSizeList?.SECOND_FIT) {
					firstTblSizeList['SECOND_FIT'] = fitWiseSizeList['SECOND_FIT'];
					secondTblSizeList['SECOND_FIT'] = fitWiseSizeList['SECOND_FIT'];
				}
				if (fitWiseSizeList?.THIRD_FIT) {
					secondTblSizeList['THIRD_FIT'] = fitWiseSizeList['THIRD_FIT'];
				}
				return (
					<>
						{Object.keys(firstTblSizeList).length > 0 && (
							<BuyerAndNitexMeasurementTable
								isMeasurementEditable={false}
								fitWiseSizeList={firstTblSizeList}
								tableData={firstAndSecondFitTableData}
								hasShowActualAndDiffColumn={hasShowActualAndDiffColumn}
								initialMeasurementTableData={firstAndSecondFitInitialData}
								//blockUsedForm={blockUsedForm}
							/>
						)}
						{Object.keys(secondTblSizeList).length > 1 && (
							<BuyerAndNitexMeasurementTable
								isMeasurementEditable={false}
								fitWiseSizeList={secondTblSizeList}
								tableData={secondAndThirdFitTableData}
								hasShowActualAndDiffColumn={hasShowActualAndDiffColumn}
								initialMeasurementTableData={secondAndThirdFitInitialData}
								//blockUsedForm={blockUsedForm}
							/>
						)}
					</>
				);
			} else if (['COSTING_GRADING', 'PP_SAMPLE'].includes(pomAndSizeList?.measurementType?.constant)) {
				return (
					<CostingAndPPSampleTable
						isMeasurementEditable={false}
						tableData={measurementTable}
						fitWiseSizeList={fitWiseSizeList}
						sizeCategorySequence={sizeCategorySequence}
						hasShowActualAndDiffColumn={hasShowActualAndDiffColumn}
						selectedMeasurementType={pomAndSizeList?.measurementType}
						//blockUsedForm={blockUsedForm}
					/>
				);
			} else {
				return <></>;
			}
		};
		return (
			<>
				{measurementTable.length > 0 && (
					<div className="single-design-view-page">
						<div className="single-artboard-title">
							<p className="regular-16 weight-500 gray_dark_01 m-0">
								MEASUREMENT CHART: {pomAndSizeList?.measurementType?.name} (
								{productInfo?.name})
							</p>
						</div>
						<div className="full-body">{renderTables()}</div>
					</div>
				)}
			</>
		);
	};

	return renderMeasurementTables();
};

export default TechPackMeasurementSection;
